export const favoriteBrandsUrl = {
  root: (buyerId: number) => `/buyers/${buyerId}/favorite-brands`,
};
